import { mouseEventHandler } from '../Utils/mouseEventHandler';

const MouseEventProivder = () => {
    mouseEventHandler();
    return null;
};
export default MouseEventProivder;
